module.exports = __webpack_public_path__ + "img/logo-gobierno.ddad4d14.jpeg";